__turbopack_context__.v({
  "actionGroup": "inAppPurchasePopover-module-scss-module__lPf4Xq__actionGroup",
  "bodyCopy": "inAppPurchasePopover-module-scss-module__lPf4Xq__bodyCopy",
  "copy": "inAppPurchasePopover-module-scss-module__lPf4Xq__copy",
  "headline": "inAppPurchasePopover-module-scss-module__lPf4Xq__headline",
  "inlineLink": "inAppPurchasePopover-module-scss-module__lPf4Xq__inlineLink",
  "section": "inAppPurchasePopover-module-scss-module__lPf4Xq__section",
  "sectionWithActions": "inAppPurchasePopover-module-scss-module__lPf4Xq__sectionWithActions",
  "strongCopy": "inAppPurchasePopover-module-scss-module__lPf4Xq__strongCopy",
  "textLink": "inAppPurchasePopover-module-scss-module__lPf4Xq__textLink",
  "textLinkCentered": "inAppPurchasePopover-module-scss-module__lPf4Xq__textLinkCentered",
});
